import React, { useEffect, useState } from 'react';
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  Text,
  VStack,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import SaktiSidebar from '../components/SaktiSidebar';
import SaktiBccImageDownloadForm from '../components/SaktiBccImageDownloadForm';
import SaktiApiService from '../services/saktiApiService';
import { SaktiFilterOptions } from '../types';
import { SAKTI_UI_SIZE } from '../uiSizes';
import extractApiError from '../utils/apiError';

const EMPTY_OPTIONS: SaktiFilterOptions = { companies: [], estates: [], divisions: [] };

const SaktiBccImageDownloadPage: React.FC = () => {
  const toast = useToast();
  const [options, setOptions] = useState<SaktiFilterOptions>(EMPTY_OPTIONS);
  const [loadingOptions, setLoadingOptions] = useState(true);

  const {
    isOpen: isMobileSidebarOpen,
    onOpen: onMobileSidebarOpen,
    onClose: onMobileSidebarClose,
  } = useDisclosure();

  useEffect(() => {
    let active = true;
    SaktiApiService.fetchFilterOptions()
      .then((opts) => {
        if (active) setOptions(opts);
      })
      .catch((err) => {
        if (!active) return;
        toast({
          title: 'Gagal memuat daftar estate',
          description: extractApiError(err).message,
          status: 'error',
          duration: 6000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => {
        if (active) setLoadingOptions(false);
      });
    return () => {
      active = false;
    };
  }, [toast]);

  return (
    <Box minH="100vh" bg="#ECEEF1">
      <Flex align="stretch">
        <Box display={{ base: 'none', xl: 'block' }}>
          <SaktiSidebar activeMenu="bcc-images" />
        </Box>

        <Drawer isOpen={isMobileSidebarOpen} placement="left" onClose={onMobileSidebarClose} size="xs">
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton zIndex={10} color="gray.500" />
            <DrawerBody p={0}>
              <SaktiSidebar activeMenu="bcc-images" />
            </DrawerBody>
          </DrawerContent>
        </Drawer>

        <Box flex={1} p={SAKTI_UI_SIZE.pagePadding} minW={0}>
          <VStack align="stretch" spacing={SAKTI_UI_SIZE.sectionGap}>
            <HStack spacing={3} align="center">
              <IconButton
                aria-label="Open menu"
                icon={<FiMenu />}
                variant="outline"
                bg="white"
                display={{ base: 'flex', xl: 'none' }}
                onClick={onMobileSidebarOpen}
              />
              <VStack align="start" spacing={0}>
                <Text fontSize={SAKTI_UI_SIZE.pageTitle} fontWeight="bold" color="gray.900" lineHeight="shorter">
                  Download Gambar BCC
                </Text>
                <Text fontSize={SAKTI_UI_SIZE.pageSubtitle} color="gray.500">
                  Sampel acak foto BCC per estate dengan komposisi jumlah janjang yang bisa diatur. Hasil berupa ZIP.
                </Text>
              </VStack>
            </HStack>

            <SaktiBccImageDownloadForm options={options} isDisabled={loadingOptions} />
          </VStack>
        </Box>
      </Flex>
    </Box>
  );
};

export default SaktiBccImageDownloadPage;
